import fileSys from "../fileoprators/fileSystem";
import { objectCopy } from "../shared/utils";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  general: {
    title: "Report",
    title_topograpy: "Report",
    paper: "A4",
    showsettings: true,
    checkdoctor: "",
    hospitalname: "",
    hospitaltel: "",
    hospitaladdr: "",
    hospitallogo: "logo.png",
    format: ".pdf",
    singlepage: true,
    anonymous: {
      patientinfo: true,
      checkdoctor: true,
      printdate: true
    }
  },
  topography: {
    currentPrintMode: "mino",
    four_maps_title: "__txtFourMaps",
    zernike_title: "__txtZernike",
    pupil_cornea_title: "__txtPupilCorneaDiameter",
    keratoconus_title: "__txtKeratoconus",
    heightf_tfsq_title: "__txtHeightF",
    fourier_analysis_title: "__txtFourierAnalysis",
    compare2records_title: "__txtCompare2Records",
    FourMaps: true,
    Zernike: false,
    PupilCornea: true,
    Keratoconus: false,
    bino: {
      FourMaps: {
        sagCurv: true,
        tanCurv: true,
        refreactive: false,
        elevation: false
      },
      Zernike: false,
      PupilCornea: false,
      Keratoconus: false
    },
    reportName: [
      "fourmaps",
      "heightfandtfsq",
      "zernike",
      "keratoconus",
      "pupilcorneadiameter",
      "fourieranalysis",
      "compare2records"
    ],
    reportName_bino: [
      "fourmaps",
      "heightfandtfsq",
      "zernike",
      "keratoconus",
      "pupilcorneadiameter",
      "fourieranalysis"
    ]
  },
  dryeye: {
    nibut: true,
    tearheight: true,
    lipidlayer: true,
    meibomian: true,
    eyelidedge: true,
    eyeredness: true,
    ocularsurface: true,
    fbut: true,
    blink: true
  },
  printConnection: "printer-USB",
  printUrl: "http://10.42.0.1:3000/upload",
  stopPrintUrl: "http://10.42.0.1:3000/stopPrint",
  meibomainReportImgSet: 1
};
class Print extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("printSettings.json"), DEFAULTSET);
  }
  getPrintSettings() {
    return this.getSettings();
  }
  savePrintSettings(settings) {
    this.saveSettings(settings);
  }
  restore() {
    window.printSettings = objectCopy(DEFAULTSET);
    this.saveSettings(window.printSettings);
  }
}
export default Print;



// WEBPACK FOOTER //
// ./src/settings/print.js